import { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

// @mui material components
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import InputAdornment from "@mui/material/InputAdornment";

// Material Dashboard 3 PRO React components
import MDInput from "components/MDInput";

import FormSelect from "components/DigiHapi/FormSelect";
import PhoneMaskInput from "components/DigiHapi/PhoneMaskInput";

import {
	fetchGetAddressUsingZipCode,
	fetchGetCityUsingZipCode,
	fetchGetAddressUsingCoordinates
} from "actions/datagouv";

import {
	CLEAR_CAMPSITE_FAX,
	CLEAR_CAMPSITE_MAIL,
	CLEAR_CAMPSITE_PHONE,
	CLEAR_CAMPSITE_WEB_SITE_URL,
	SET_CAMPSITE_ADDRESS,
	SET_CAMPSITE_CITY,
	SET_CAMPSITE_FAX,
	SET_CAMPSITE_FAX_ERROR,
	SET_CAMPSITE_MAIL,
	SET_CAMPSITE_MAIL_ERROR,
	SET_CAMPSITE_PHONE,
	SET_CAMPSITE_PHONE_ERROR,
	SET_CAMPSITE_WEB_SITE_URL,
	SET_CAMPSITE_WEB_SITE_URL_ERROR,
	SET_CAMPSITE_ZIP_CODE,
	SET_CAMPSITE_SELECTED_CITY,
	SET_CAMPSITE_SELECTED_ADDRESS,
	SET_CAMPSITE_SELECTED_ZIPCODE
} from "actions/types";

const OTHER = "Autre ...";

// Clickable "clear" adornment displayed at the end of an input
const clearAdornment = onClick => (
	<InputAdornment position="end">
		<Icon color="error" sx={{ cursor: "pointer" }} onClick={onClick}>
			close
		</Icon>
	</InputAdornment>
);

// Options of the address / zip code / city selects ("Autre ..." switches to a free text input)
const toOptions = data => data.map(obj => ({ value: obj, label: obj }));

class Step2 extends Component {
	sendState() {
		return this.state;
	}

	isValidated() {
		const { dispatch, phoneState, faxState, webSiteUrlState, mailState } =
			this.props;

		let success = true;
		if (phoneState === "error") {
			dispatch({
				type: SET_CAMPSITE_PHONE_ERROR
			});
			success = false;
		}
		if (faxState === "error") {
			dispatch({
				type: SET_CAMPSITE_FAX_ERROR
			});
			success = false;
		}
		if (webSiteUrlState === "error") {
			dispatch({
				type: SET_CAMPSITE_WEB_SITE_URL_ERROR
			});
			success = false;
		}
		if (mailState === "error") {
			dispatch({
				type: SET_CAMPSITE_MAIL_ERROR
			});
			success = false;
		}
		return success;
	}

	render() {
		const {
			dispatch,
			phone,
			phoneState,
			phoneErrorMsg,
			fax,
			faxState,
			faxErrorMsg,
			customAddress,
			address,
			addresses,
			selectedAddress,
			addressUpdated,
			zipCodes,
			selectedZipCode,
			customZipCode,
			zipCode,
			zipCodeUpdated,
			cities,
			selectedCity,
			customCity,
			webSiteUrl,
			webSiteUrlState,
			webSiteUrlErrorMsg,
			mail,
			mailState,
			mailErrorMsg,
			longitude,
			latitude
		} = this.props;
		return (
			<Grid container spacing={3} justifyContent="center">
				<Grid item xs={12}>
					{selectedAddress === OTHER ? (
						<MDInput
							label="Adresse"
							id="address"
							fullWidth
							value={customAddress || ""}
							onChange={e =>
								dispatch({
									type: SET_CAMPSITE_ADDRESS,
									value: e.target.value
								})
							}
							onBlur={() => {
								if (addressUpdated && address) {
									if (zipCode) {
										this.props.fetchGetAddressUsingZipCode({
											address,
											zipCode
										});
									} else if (longitude && latitude) {
										this.props.fetchGetAddressUsingCoordinates({
											address,
											latitude,
											longitude
										});
									}
								}
							}}
						/>
					) : (
						<FormSelect
							label="Adresse"
							value={selectedAddress ? selectedAddress : ""}
							placeholder={OTHER}
							placeholderSelectable
							options={toOptions(Object.keys(addresses))}
							onChange={(e, child) =>
								dispatch({
									type: SET_CAMPSITE_SELECTED_ADDRESS,
									payload: child.props.children
								})
							}
						/>
					)}
				</Grid>
				<Grid item xs={12}>
					{selectedZipCode === OTHER ? (
						<MDInput
							label="Code postal"
							id="zipcode"
							fullWidth
							value={customZipCode || ""}
							onChange={e =>
								dispatch({
									type: SET_CAMPSITE_ZIP_CODE,
									value: e.target.value
								})
							}
							onBlur={() =>
								zipCodeUpdated &&
								zipCode &&
								this.props.fetchGetCityUsingZipCode({ address, zipCode })
							}
						/>
					) : (
						<FormSelect
							label="Code postal"
							value={selectedZipCode ? selectedZipCode : ""}
							placeholder={OTHER}
							placeholderSelectable
							options={toOptions(Object.keys(zipCodes))}
							onChange={(e, child) =>
								dispatch({
									type: SET_CAMPSITE_SELECTED_ZIPCODE,
									payload: child.props.children
								})
							}
						/>
					)}
				</Grid>
				<Grid item xs={12}>
					{selectedCity === OTHER ? (
						<MDInput
							label="Ville"
							id="city"
							fullWidth
							value={customCity || ""}
							onChange={e =>
								dispatch({
									type: SET_CAMPSITE_CITY,
									value: e.target.value
								})
							}
						/>
					) : (
						<FormSelect
							label="Ville"
							value={selectedCity ? selectedCity : ""}
							placeholder={OTHER}
							placeholderSelectable
							options={toOptions(Object.keys(cities))}
							onChange={(e, child) =>
								dispatch({
									type: SET_CAMPSITE_SELECTED_CITY,
									payload: child.props.children
								})
							}
						/>
					)}
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="Téléphone"
						id="phone"
						fullWidth
						success={!!phone && phoneState === "success"}
						error={phoneState === "error"}
						helperText={phoneErrorMsg}
						placeholder="+33 (0)X XX XX XX XX"
						value={phone || ""}
						onChange={e =>
							dispatch({
								type: SET_CAMPSITE_PHONE,
								value: e.target.value
							})
						}
						InputProps={{
							inputComponent: PhoneMaskInput,
							endAdornment:
								phone !== null &&
								clearAdornment(() =>
									dispatch({
										type: CLEAR_CAMPSITE_PHONE
									})
								)
						}}
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="Fax"
						id="fax"
						fullWidth
						success={!!fax && faxState === "success"}
						error={faxState === "error"}
						helperText={faxErrorMsg}
						placeholder="+33 (0)X XX XX XX XX"
						value={fax || ""}
						onChange={e =>
							dispatch({
								type: SET_CAMPSITE_FAX,
								value: e.target.value
							})
						}
						InputProps={{
							inputComponent: PhoneMaskInput,
							endAdornment:
								fax !== null &&
								clearAdornment(() =>
									dispatch({
										type: CLEAR_CAMPSITE_FAX
									})
								)
						}}
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="Url site internet"
						id="url"
						fullWidth
						type="text"
						helperText={webSiteUrlErrorMsg}
						success={!!webSiteUrl && webSiteUrlState === "success"}
						error={webSiteUrlState === "error"}
						value={webSiteUrl || ""}
						onChange={e =>
							dispatch({
								type: SET_CAMPSITE_WEB_SITE_URL,
								value: e.target.value
							})
						}
						InputProps={{
							endAdornment:
								webSiteUrl !== null &&
								clearAdornment(() =>
									dispatch({
										type: CLEAR_CAMPSITE_WEB_SITE_URL
									})
								)
						}}
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="Email de contact"
						id="mail"
						fullWidth
						type="text"
						helperText={mailErrorMsg}
						success={!!mail && mailState === "success"}
						error={mailState === "error"}
						value={mail || ""}
						onChange={e =>
							dispatch({
								type: SET_CAMPSITE_MAIL,
								value: e.target.value
							})
						}
						InputProps={{
							endAdornment:
								mail !== null &&
								clearAdornment(() =>
									dispatch({
										type: CLEAR_CAMPSITE_MAIL
									})
								)
						}}
					/>
				</Grid>
			</Grid>
		);
	}
}

const mapStateToProps = state => {
	const {
		_id,
		isFetching,
		isFetchingList,
		name,
		nameErrorMsg,
		addressUpdated,
		customAddress,
		addresses,
		selectedAddress,
		address,
		customZipCode,
		zipCodes,
		selectedZipCode,
		zipCode,
		zipCodeUpdated,
		customCity,
		city,
		cities,
		selectedCity,
		webSiteUrl,
		mail,
		latitude,
		longitude,
		phone,
		fax,
		registerkey,
		files,
		logoUri,
		mapUri,
		mapSmallUri,
		phoneErrorMsg,
		phoneState,
		faxErrorMsg,
		faxState,
		webSiteUrlState,
		webSiteUrlErrorMsg,
		mailState,
		mailErrorMsg
	} = state.campsiteReducer;
	return {
		_id,
		isFetching,
		isFetchingList,
		name,
		nameErrorMsg,
		address,
		customAddress,
		addresses,
		selectedAddress,
		addressUpdated,
		zipCode,
		customZipCode,
		zipCodes,
		selectedZipCode,
		zipCodeUpdated,
		customCity,
		city,
		cities,
		selectedCity,
		webSiteUrl,
		mail,
		latitude,
		longitude,
		phone,
		fax,
		registerkey,
		files,
		logoUri,
		mapUri,
		mapSmallUri,
		phoneErrorMsg,
		phoneState,
		faxErrorMsg,
		faxState,
		webSiteUrlState,
		webSiteUrlErrorMsg,
		mailState,
		mailErrorMsg
	};
};

const mapDispatchToProps = dispatch => {
	let actions = bindActionCreators(
		{
			fetchGetAddressUsingZipCode,
			fetchGetCityUsingZipCode,
			fetchGetAddressUsingCoordinates
		},
		dispatch
	);
	return { ...actions, dispatch };
};
export default connect(mapStateToProps, mapDispatchToProps, null, {
	forwardRef: true
})(Step2);
